<template>
  <item-list
    :items="shownEvents"
    :data-table-config="dataTableConfig"
    :actions="actions"
    show-actions
  >
    <template v-slot:header>
      <div>
        <h1>Turnierverwaltung</h1>
        <v-checkbox
          v-model="showOldEvents"
          class="mt-0"
          label="Vergangene Turniere anzeigen"
          hide-details
        ></v-checkbox>
      </div>
    </template>
  </item-list>
</template>

<script>
import { mapState } from "vuex";
import ItemList from "../common/ItemList";
import moment from "moment";

export default {
  components: {
    "item-list": ItemList
  },
  computed: {
    shownEvents() {
      if (this.showOldEvents) {
        return this.events;
      }

      return this.events.items.filter(e => {
        const endDate = moment(e.end);
        return endDate.diff(moment(), "days") >= 0;
      });
    },
    ...mapState(["events", "user"])
  },
  data() {
    return {
      lockActions: false,
      showOldEvents: false,
      dataTableConfig: {
        loadingDataText: "Lade Turniere",
        noDataText: "Keine Turniere verfügbar",
        rowsPerPageText: "Zeilen pro Seite",
        headers: [
          { text: "#", value: "id", align: "left" },
          { text: this.$t("name"), value: "name", align: "left" },
          { text: this.$t("start"), value: "start", align: "left" },
          { text: this.$t("end"), value: "end", align: "left" },
          {
            text: this.$t("event_rules"),
            value: "event_rule.name",
            align: "left"
          }
        ],
        items: {
          large: [
            { value: "id", class: "text-xs-left" },
            { value: "name", class: "text-xs-left" },
            { value: "start", formatFunction: "$formatDate" },
            { value: "end", formatFunction: "$formatDate" },
            { value: "event_rule.name", formatFunction: "$toUpperCase" }
          ],
          small: [{ value: "name" }]
        }
      },
      actions: [
        {
          label: this.$t("remove_starters"),
          icon: "clear",
          loading: event => {
            return (
              event.deletingStarters !== undefined && event.deletingStarters
            );
          },
          visible: event => {
            return event.has_starters;
          },
          click: event => {
            this.$store.commit("confirm", {
              headline: "Offene Meldungen wirklich entfernen?",
              text: this.$t("questions.unregister_all_starters", [event.name]),
              callback: () => {
                this.$set(event, "deletingStarters", true);

                axios.delete(`/api/v1/events/${event.id}/delete_starters`).then(
                  response => {
                    if (!response.data.success) {
                      return;
                    }

                    this.$store.dispatch("loadEvents");
                  },
                  () => {
                    this.$delete(event, "deletingStarters");
                  }
                );
              }
            });
          }
        },
        {
          label: this.$t("invoice_download"),
          icon: "description",
          visible: event => {
            return event.has_invoices;
          },
          click: event => {
            const token = this.user.api_token;
            const link = document.createElement("a");
            link.href = `https://app.streetdancefactory.de/meldeportal/api/v1/events/invoices/${
              event.id
            }?api_token=${token}`;
            // link.href = `http://localhost:81/api/v1/events/invoices/${event.id}?api_token=${token}`;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
          }
        },
        // {
        //   label: 'Zeitplan',
        //   icon: 'access_time',
        //   disabled: event => {
        //     return event.is_deletable;
        //   },
        //   click: event => {
        //     this.$router.push(`/admin/event_schedules/${event.id}`);
        //   }
        // },
        {
          label: "Tänzerstatistik",
          icon: "group",
          click: event => {
            window.location.href = `/admin/events/${
              event.id
            }/statistics/dancer`;
          }
        },
        {
          label: this.$t("media_download"),
          icon: "cloud_download",
          disabled: event => {
            return !event.has_media;
          },
          click: event => {
            const token = this.user.api_token;
            const link = document.createElement("a");
            link.href = `https://app.streetdancefactory.de/meldeportal/api/v1/events/media/${
              event.id
            }?api_token=${token}`;
            // link.href = `http://localhost:81/api/v1/events/music/${event.id}?api_token=${token}`;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
          }
        },
        {
          label: "Veranstaltung duplizieren",
          icon: "content_copy",
          click: event => {
            this.$router.push(`/admin/events/create?base_event_id=${event.id}`);
          }
        },
        {
          label: this.$t("edit"),
          icon: "edit",
          click: event => {
            this.$router.push(`/admin/events/${event.id}`);
          }
        },
        {
          label: this.$t("delete"),
          icon: "delete",
          disabled: event => {
            return !event.is_deletable;
          },
          click: item => {
            this.$store.commit("confirm", {
              headline: this.$t("delete_event"),
              text: this.$t("questions.remove", [item.name]),
              callback: () => {
                this.lockActions = true;

                axios.delete(`/api/v1/events/${item.id}`).then(
                  response => {
                    if (!response.data.success) {
                      return;
                    }

                    this.$store.commit(this.actions.remove, item.id);

                    this.$store.commit("snackBar", {
                      color: "success",
                      text: this.$t("was_deleted", [item.name])
                    });

                    this.lockActions = false;
                  },
                  errorResponse => {
                    console.log(errorResponse);
                    this.lockActions = false;
                  }
                );
              }
            });
          }
        }
      ]
    };
  }
};
</script>
